import { Link } from "react-router-dom";
import { useFormState } from "./Context";

const decimalControl = (num, numCal) => {
  const numberCalculation = Number(num) * numCal;
  if (numberCalculation % 1 !== 0) {
    return parseFloat(numberCalculation).toFixed(4);
  } else {
    return numberCalculation;
  }
};

export const Congrats = (props) => {
  const [formState] = useFormState();
  // const formData = {
  //   firstname: "Silvio Wed Test",
  //   lastname: "Doe",
  //   email: "johndoe@example.com",
  //   company: "Example Corp.",
  //   jobtitle: "Developer",
  //   leadSource: "Web",
  //   leadSourceDetail: "Google",
  //   conversionDate: "2023-09-28", // Format the date as needed
  //   conversionPage: "https://www.example.com/signup",
  //   conversionTitle: "Signup Page",
  // };
  
  function sendToHubSpot(formData) {
    const portalId = "2886100"; // replace with your HubSpot portal ID
    const formGuid = "df4c65be-00f2-46c5-815e-dfe24cb3425c"; // replace with your HubSpot form GUIDplace with your HubSpot form GUID
    const endpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
    const data = {
      fields: [
        { name: "firstname", value: formData.firstname },
        { name: "lastname", value: formData.lastname },
        { name: "email", value: formData.email },
        { name: "company", value: formData.company },
        { name: "jobtitle", value: formData.jobtitle },
        { name: "Lead source", value: formData.leadSource },
        { name: "Lead Source Detail", value: formData.leadSourceDetail },
        { name: "Conversion Date", value: formData.conversionDate },
        { name: "Conversion Page", value: formData.conversionPage },
        { name: "Conversion Title", value: formData.conversionTitle },
      ],
      skipValidation: true, // Skip HubSpot validation; set to false if you want to validate data
    };

 

    // axios
    //   .post(endpoint, data)
    //   .then((response) => {
    //     console.log("Data sent successfully:", response.data);
    //   })
    //   .catch((error) => {
    //     console.error("Error sending data to HubSpot:", error);
    //   });
  }



  return (
    <>
      {/* <button onClick={() => sendToHubSpot(formData)}>Test</button> */}
      <div className="h-28 border  flex ">
        <div className="container mx-auto flex items-center">
          <Link to="/" className="text-2xl font-bold text-gray-800">
            <img src="/logo.png" className="w-40" alt="" />
          </Link>
        </div>
      </div>
      <div>
        <div>
          <img src="/confetti.jpg"></img>
        </div>
        <div className="container mx-auto py-2 flex justify-center">
          <div className="text-2xl font-bold text-blue-900 mt-3">
            Congratulations!
          </div>
        </div>
        <div className="container mx-auto py-2 flex justify-center">
          <div className="text-xl font-bold text-blue-900">
            Your organization could be a great fit for Verusen to help!
          </div>
        </div>
        <div className="container mx-auto py-2 flex justify-center">
          <div className="text-lg  text-blue-900 text-center">
            Based on your inputs, we estimate we could identify these impactful
            material opportunities, amongst many others that will <br />{" "}
            continuously optimize your MRO inventory across your organization.
          </div>
        </div>
      </div>
      <div className="container mx-auto py-11 flex justify-center space-x-32 text-blue-900">
        <div>
          <div className="font-medium text-4xl">
            {decimalControl(formState.onHandInventory, 0.0303)}
          </div>
          <div className="text-center mt-2">Overmax</div>
        </div>
        <div>
          <div className="font-medium text-4xl text-center">
            {decimalControl(formState.estimated12Months, 0.1031)}
          </div>
          <div className="text-center mt-2">Pricing Gap</div>
        </div>
        <div>
          <div className="font-medium text-4xl text-center">
            {decimalControl(formState.onHandInventory, 0.0886)}
          </div>
          <div className="text-center mt-2"> Material Optimization</div>
        </div>
        <div>
          <div className="font-medium text-4xl text-center">
            {decimalControl(formState.onHandInventory, 0.0289)}
          </div>
          <div className="text-center mt-2">
            Incremental Network Optimization
          </div>
        </div>
      </div>
    </>
  );
};
